import React from "react";
import Topic from "./Topic";
import EmptyTopic from "./EmptyTopic";

export default function Topics({ latestData, getTopicsPgnation }) {
  console.log(latestData);
  let content = null;
  if (latestData.length > 0) {
    content = getTopicsPgnation().data.map((comment, index) => {
      if (comment !== null) {
        return <Topic key={index} comment={comment} index={index} />;
      } else {
        return <EmptyTopic />;
      }
    });
  }

  return content;
}
